import { render, staticRenderFns } from "./pagination-table.vue?vue&type=template&id=37665a6b&scoped=true"
import script from "./pagination-table.vue?vue&type=script&lang=js"
export * from "./pagination-table.vue?vue&type=script&lang=js"
import style0 from "./pagination-table.vue?vue&type=style&index=0&id=37665a6b&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37665a6b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/apps/wpms/web/wind-plannerDev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37665a6b')) {
      api.createRecord('37665a6b', component.options)
    } else {
      api.reload('37665a6b', component.options)
    }
    module.hot.accept("./pagination-table.vue?vue&type=template&id=37665a6b&scoped=true", function () {
      api.rerender('37665a6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pagination-table.vue"
export default component.exports